import { useParams } from 'react-router';
import { ICalendar } from '@/types';
import { getUrl } from '@/utils/api';

function useCalendar(id?: string) {
  const { calendarId } = useParams();
  const query = getUrl(`v1/calendars/${id ? id : calendarId}`);
  return {
    ...query,
    data: query.data as ICalendar,
  };
}

export default useCalendar;
